import { Checkbox, CheckboxProps, Tooltip } from '@mantine/core';
import { IconSlash } from '@tabler/icons-react'; // 예시 아이콘
import { useTranslation } from 'react-i18next';

const CheckboxIcon: CheckboxProps['icon'] = ({ ...others }) => (
    <IconSlash size={20} {...others} />
);

export default function CancelCheckBox({
    checked,
    onChange,
    disabled = false,
}: {
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
}) {
    const { t } = useTranslation('todo');

    return (
        <Tooltip
            label={
                // 비활성화 상태면 '상태값'을, 아니면 '변경될 값'을 표시
                disabled
                    ? checked
                        ? t('status.cancelled')
                        : t('status.in_progress')
                    : checked
                      ? t('component.cancel_checkbox.resume')
                      : t('component.cancel_checkbox.cancel')
            }
            withArrow
        >
            <Checkbox
                variant="outline"
                bg={checked ? '#F1F3F5' : 'transparent'}
                styles={{
                    root: {
                        borderRadius: '4px',
                    },
                    input: {
                        borderRadius: '4px',
                    },
                    inner: {
                        borderRadius: '4px',
                    },
                }}
                radius="md"
                color="#DEE2E6"
                checked={checked}
                onChange={e => onChange(e.target.checked)}
                aria-label={
                    checked
                        ? t('component.cancel_checkbox.aria_resume')
                        : t('component.cancel_checkbox.aria_cancel')
                }
                size="xs"
                icon={props => (
                    <IconSlash {...props} stroke={4} color="#ADB5BD" />
                )}
            />
        </Tooltip>
    );
}
